module.exports = __webpack_public_path__ + "static/media/1.2e139e29.png";